<template>
  <a href="/" class="no-underline">
    <p class="header-title"><slot name="default"></slot><span class="article-dot">.</span></p>
    <p v-if="environment" class="environment-name">{{ environment }}</p>
  </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HeaderLogo',
  data: () => {
    return {
      environment: process.env.VUE_APP_ENV,
    };
  },
});
</script>

<style lang="scss" scoped>
* {
  font-size: var(--font-size-24);
  font-weight: bold;
  text-transform: uppercase;
  color: var(--lightgrey);
  margin: 0;
  padding: 0;
  letter-spacing: 0.1em;
}

.header-title {
  margin-bottom: 8px;
}

.article-dot {
  color: var(--coral);
}

.no-underline {
  text-decoration: none;
}

.environment-name {
  color: var(--coral);
  font-size: 0.5em;
  line-height: 0.5em;
}
</style>
